// extracted by mini-css-extract-plugin
module.exports = {"error_icon":"styles_error_icon__rtr-Z","error_content":"styles_error_content__5uwlD","error_context":"styles_error_context__1HzZ8","footer_error":"styles_footer_error__2mI3a"};